import { RootState } from 'types';

export const selectShowToast = (state: RootState) =>
  state?.errorHandling?.showToast;
export const selectToastDelay = (state: RootState) =>
  state?.errorHandling?.toastDelay;
